// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3IsEN","icon":"SortAdornment_icon__1rFRI","up":"SortAdornment_up__24V5h","down":"SortAdornment_down__3QqxM","active":"SortAdornment_active__6aIwp"};